import { FormHelperText as ChakraFormHelperText } from '@chakra-ui/react';

type FormHelperTextProps = React.ComponentProps<typeof ChakraFormHelperText>;

const FormHelperText = ({
  children,
  ...props
}: Readonly<FormHelperTextProps>) => {
  return <ChakraFormHelperText {...props}>{children}</ChakraFormHelperText>;
};

export default FormHelperText;
